import {Roles} from 'app/Constants';
import authFetch from './requests';

function entriesPolyFill(obj) {
  const keys = Object.keys(obj);

  const keyValuePairs = keys.map((key) => {
    const value = obj[key];

    return [key, value];
  });

  return keyValuePairs;
}

// const pushIntoArray = (objectToPush:any, array:any[]) => {
const pushIntoArray = (objectToPush, array) => {
  let arrayCopy = [...array];
  arrayCopy.push(objectToPush);
  return [...arrayCopy];
};

// const putIntoObjectAt = (newValue:any, obj:any, ix:any) => {
const putIntoObjectAt = (newValue, obj, ix) => {
  let objCopy = {...obj};
  objCopy[ix] = newValue;
  return {...objCopy};
};

// const putIntoArrayAt = (newValue:any, array:any[], ix:any) => {
const putIntoArrayAt = (newValue, array, ix) => {
  let arrayCopy = [...array];
  arrayCopy[ix] = newValue;
  return [...arrayCopy];
};

const roleCompare = (a, b) => {
  let first = 0;
  let second = 0;
  if (a.role === Roles.AdminITPS) {
    first = 5;
  } else if (a.role === Roles.AdminQA) {
    first = 4;
  } else if (a.role === Roles.AdminHSE) {
    first = 3;
  } else if (a.role === Roles.Trainer) {
    first = 2;
  } else {
    first = 1;
  }

  if (b.role === Roles.AdminITPS) {
    second = 5;
  } else if (b.role === Roles.AdminQA) {
    second = 4;
  } else if (b.role === Roles.AdminHSE) {
    second = 3;
  } else if (b.role === Roles.Trainer) {
    second = 2;
  } else {
    second = 1;
  }

  if (first > second) {
    return -1;
  }
  if (first < second) {
    return 1;
  }
  if (first === second) {
    return 0;
  }
};

async function print(url, cwid, token, pdfName) {
  try {
    const response = await authFetch(
      `${url}`,
      {
        method: 'GET',
        responseType: 'blob',
      },
      token,
    );
    response.blob().then((x) => {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var file = new Blob([x], {type: 'application/pdf'});
        window.navigator.msSaveOrOpenBlob(file, cwid + pdfName);
      } else {
        const fileURL = URL.createObjectURL(x);
        //Open the URL on new Window
        var winparams =
          'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
          'resizable,screenX=50,screenY=50,width=850,height=1050';

        window.open(fileURL, 'Reporte', winparams);
      }
    });
  } catch (error) {
    console.log(error); //¿Que hacemos con el error?
  }
}

function compare(a, b) {
  if (a.iD_Answer < b.iD_Answer) {
    return -1;
  }
  if (a.iD_Answer > b.iD_Answer) {
    return 1;
  }
  return 0;
}

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  var aSorted = a.sort(compare);
  var bSorted = b.sort(compare);
  for (var i = 0; i < aSorted.length; ++i) {
    if (aSorted[i] !== bSorted[i]) {
      return false;
    }
  }
  return true;
}

function matchYoutubeUrl(url) {
  var p =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  if (url.match(p)) {
    return url.match(p)[1];
  }
  return false;
}

function matchStreamUrl(url) {
  const streamUrlPattern =
    /https:\/\/web\.microsoftstream\.com\/video\/([a-z0-9-]+)/i;
  const match = url.match(streamUrlPattern);
  if (match) {
    return match[1];
  } else {
    return false;
  }
}

function arraysEqualMasterGrid(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  function compareArrays(a, b) {
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (Array.isArray(a[i]) && Array.isArray(b[i])) {
        if (!compareArrays(a[i], b[i])) return false;
      } else {
        if (a[i] !== b[i]) return false;
      }
    }
    return true;
  }

  var aSorted = a.sort(compare);
  var bSorted = b.sort(compare);

  for (var i = 0; i < aSorted.length; ++i) {
    if (!compareArrays(aSorted[i], bSorted[i])) return false;
  }

  return true;
}

export {
  entriesPolyFill,
  pushIntoArray,
  putIntoObjectAt,
  putIntoArrayAt,
  roleCompare,
  print,
  compare,
  arraysEqualMasterGrid,
  arraysEqual,
  matchYoutubeUrl,
  matchStreamUrl,
};
